import React from 'react';
import SettingsContainer from '../components/settings/SettingsContainer';

export default function Settings() {
  return <SettingsContainer />;
}
